import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { SearchInputEmployee } from 'src/pages/DashboardPage/mytasks/meetingsPage/components/SearchInputEmployee';
import { PersonType } from 'src/pages/DashboardPage/mytasks/meetingsPage/type';
import { TGSelectPickerByList } from '../ui/TGSelect';
import { Status } from 'src/modules/modules.type';
import { Option } from '../ui/TGSelect';
import { TGDisclosure } from '../ui/TGDisclosure';

type ResponseData = {
  data: {
    ID: number;
    Title: string;
  }[];
  status: Status;
}

type FilterMeetingsProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedPerson: PersonType | null | undefined;
  onChangePerson: (person: PersonType | null) => void;
  locationsResponseData: ResponseData;
  locations: Option[];
  onSetLocations: (values: {id: string; name: string;}[]) => void;
  departmentsResponseData: ResponseData;
  departments: Option[];
  onSetDepartments: (values: {id: string; name: string;}[]) => void;
  frequencyList: {id: string; name: string;}[];
  frequencies: Option[];
  onSetFrequencies: (values: {id: string; name: string;}[]) => void;
  onResetFilterLocation: () => void;
  onResetDepartments: () => void;
  onResetFrequencies: () => void;
  onResetPerson: () => void;
  onResetAllFilters: () => void;
  isSelectedFilters: boolean;
}

function FilterMeetings(props: FilterMeetingsProps) {
  const { isOpen, onClose, selectedPerson, onChangePerson, locationsResponseData, locations, onSetLocations, departmentsResponseData, departments, onSetDepartments, frequencyList, frequencies, onSetFrequencies, onResetFilterLocation, onResetDepartments, onResetFrequencies, onResetPerson, onResetAllFilters, isSelectedFilters } = props;

  return (
    <Dialog open={isOpen} onClose={onClose} className="z-40">
      <div className="fixed inset-0 overflow-y-auto overflow-x-hidden touch-auto z-40">
        <div className="min-h-full bg-white py-6">
          <div className="pb-6 border-b border-gray-500">
            <div className="flex align-middle justify-between px-6">
              <span>Фильтры</span>

              <button
                type="button"
                onClick={onClose}
                >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
          </div>

          <div>
            <div className="flex flex-col custom-selects">
              <TGDisclosure
                title="Локация"
                wrapperClassName='pb-5 px-6'
                buttonClassName='px-0'
                panelClassName='p-0 gap-y-0'
                defaultOpen={true}
              >
                <TGSelectPickerByList
                  list={locationsResponseData.data.map((d) => ({ id: d.ID.toString(), name: d.Title }))}
                  values={locations}
                  onChange={(values) => onSetLocations(values)}
                  fetchKey="Region"
                  classNames={{ selectClassName: "!px-5", labelClassName: "hidden" }}
                  searchPlaceholder="Найти локацию"
                  dataField={{
                    placeholder: "Выберите локацию",
                    type: "peoplePicker",
                    require: false,
                    title: "Локация",
                    width: "w-full",
                    key: "peoplePicker",
                    single: true,
                    hideRemoveButton: true
                  }}
                  errors={{}}
                />

                <button type='button' className='flex gap-0.5 items-center' onClick={onResetFilterLocation}>
                  Сбросить фильтры
                  <XMarkIcon aria-hidden="true" className="h-4 w-4" />
                </button>
              </TGDisclosure>

              <TGDisclosure
                title="Отдел"
                wrapperClassName='pb-5 px-6'
                buttonClassName='px-0'
                panelClassName='p-0 gap-y-0'
                defaultOpen={true}
              >
                <TGSelectPickerByList
                  list={departmentsResponseData.data.map((d) => ({ id: d.ID.toString(), name: d.Title }))}
                  values={departments}
                  onChange={(values) => onSetDepartments(values)}
                  fetchKey="Department"
                  classNames={{ selectClassName: "!px-5", labelClassName: "hidden" }}
                  searchPlaceholder="Найти отдел"
                  dataField={{
                    placeholder: "Выберите отдел",
                    type: "peoplePicker",
                    require: false,
                    title: "Отдел",
                    width: "w-full",
                    key: "peoplePicker",
                    single: true,
                    hideRemoveButton: true
                  }}
                  errors={{}}
                />

                <button type='button' className='flex gap-0.5 items-center' onClick={onResetDepartments}>
                  Сбросить фильтры
                  <XMarkIcon aria-hidden="true" className="h-4 w-4" />
                </button>
              </TGDisclosure>

              <TGDisclosure
                title="Периодичность"
                wrapperClassName='pb-5 px-6'
                buttonClassName='px-0'
                panelClassName='p-0 gap-y-0'
                defaultOpen={true}
              >
                <TGSelectPickerByList
                  values={frequencies}
                  onChange={(values) => onSetFrequencies(values)}
                  fetchKey="Frequencies"
                  classNames={{ selectClassName: "!px-5", labelClassName: "hidden" }}
                  searchPlaceholder="Найти периодичность"
                  dataField={{
                    placeholder: "Выберите периодичность",
                    type: "peoplePicker",
                    require: false,
                    title: "Периодичность",
                    width: "w-full",
                    key: "peoplePicker",
                    single: true,
                    hideRemoveButton: true
                  }}
                  list={frequencyList}
                  errors={{}}
                />

                <button type='button' className='flex gap-0.5 items-center' onClick={onResetFrequencies}>
                  Сбросить фильтры
                  <XMarkIcon aria-hidden="true" className="h-4 w-4" />
                </button>
              </TGDisclosure>

              <TGDisclosure
                title="ФИО участника"
                wrapperClassName='pb-5 no-label px-6'
                buttonClassName='px-0'
                panelClassName='p-0 gap-y-0'
                defaultOpen={true}
              >
                <SearchInputEmployee selectedPerson={selectedPerson} changePerson={onChangePerson} />

                <button type='button' className='flex gap-0.5 items-center' onClick={onResetPerson}>
                  Сбросить фильтры
                  <XMarkIcon aria-hidden="true" className="h-4 w-4" />
                </button>
              </TGDisclosure>

              <div className='flex flex-col gap-2 pt-4 px-6'>
                <button
                  type='button'
                  className="rounded-md px-6 py-4 shadow-md bg-[#012169] text-white"
                  onClick={onClose}
                >
                  Применить фильтры
                </button>

                <button
                  type='button'
                  className={`rounded-md px-6 py-4 shadow-md bg-white text-[#012169] border border-[#DFE4EA] ${!isSelectedFilters ? 'opacity-50 cursor-not-allowed' : ''}`}
                  onClick={onResetAllFilters}
                  disabled={!isSelectedFilters}
                >
                  Сбросить все фильтры
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default FilterMeetings;
